import React, { Component } from "react";
import { _ } from "libs";
import { ITNRating } from "../../../types";
import Loader from "../../loader";
import Modal from "../../modal";

const ITNSelector = ({ ratings, onSelect }) => {
	return (
		<ul className="itns">
			{[...ratings].reverse().map(({ ratingCode, ratingDescription, ratingName }) => (
				<li key={ratingCode} onClick={onSelect.bind(null, ratingCode)}>
					<h3>
						<span className="orange">{ratingCode.replace("ITN", "")}</span> {ratingName}
					</h3>
					<p className="note">{ratingDescription}</p>
				</li>
			))}
		</ul>
	);
};

type Props = {
	onChange: Function;
	value?: string;
	ratings: {
		ITN: {
			ratings: Array<ITNRating>;
		};
	};
	asLink?: boolean;
	onResetClicked?: Function;
};

type State = {
	showModal: boolean;
};

export class ITNLevelInput extends Component<Props, State> {
	constructor(props) {
		super(props);

		this.state = {
			showModal: false,
		};
	}

	handleShowModal = () => {
		this.setState({ showModal: true });
	};

	handleHideModal = () => {
		this.setState({ showModal: false });
	};

	onSelect = (ratingCode: string) => {
		this.props.onChange(ratingCode);
		this.handleHideModal();
	};

	findITNDescription = (ratingCode: string): string => {
		for (let rating of this.props.ratings.ITN.ratings) {
			if (rating.ratingCode === ratingCode) {
				return `${ratingCode} - ${rating.ratingName}`;
			}
		}

		return ratingCode;
	};

	handleReset = () => {
		if (this.props.onResetClicked) {
			this.props.onResetClicked();
		}
	};

	render() {
		if (!this.props.ratings.hasOwnProperty("ITN")) {
			return <Loader />;
		}

		return (
			<>
				<input type="hidden" value={this.props.value || ""} readOnly />
				{!this.props.asLink ? (
					<div className="dropdown2">
						<div className="dropdownBody" onClick={this.handleShowModal}>
							{this.props.value !== null
								? this.findITNDescription(this.props.value)
								: _("onboarding.itnLevel.placeholder")}
						</div>
						{this.props.value ? (
							<div className="dropdownIcon cancel" onClick={this.handleReset} />
						) : (
							<div className="dropdownIcon down" onClick={this.handleShowModal} />
						)}
					</div>
				) : (
					<p className="mt-16">
						<span onClick={this.handleShowModal} className="link">
							{_("onboarding.itnLevel.placeholder")}
						</span>
					</p>
				)}

				{this.state.showModal ? (
					<Modal
						title={_("onboarding.itnLevel.modal.title")}
						onCloseClicked={this.handleHideModal}
						className="scrollable"
					>
						<ITNSelector ratings={this.props.ratings.ITN.ratings} onSelect={this.onSelect} />
					</Modal>
				) : null}
			</>
		);
	}
}

export default ITNLevelInput;
